<template>
  <div class="w-20">
    <VDropdown
      ref="dropdownRef"
      v-model="selectedCommmodity"
      size="xs"
      :options="legends as Option[]"
      theme="dark"
      container-classes="right-0 w-40 mt-1 "
      @update:model-value="select"
    >
      <template #current-single="{ item }">
        <span class="truncate">{{ item.name }}</span>
      </template>
      <template #option="{ item }">
        <div class="py-1 px-2">
          <span class="py-1 px-2 text-sm truncate">{{ item.name }}</span>
        </div>
      </template>
    </VDropdown>
  </div>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { ref, watch } from 'vue'

import type { Option } from '~/components/VDropdown.vue'

const props = defineProps({
  legends: {
    type: Array as PropType<DeepReadonly<Option[]>>,
    required: true,
  },
  selectedLegend: {
    type: Object as PropType<Option>,
    required: true,
  },
})

const emit = defineEmits(['select'])

const selectedCommmodity = ref<Option>({ id: '', name: '' })

watch(
  () => props.legends,
  () => {
    selectedCommmodity.value = props.selectedLegend
  },
  { immediate: true },
)

function select(commodity: Option) {
  emit('select', commodity)
  selectedCommmodity.value = commodity
}
</script>
